import ManualFileHeader from './ManualFileHeader'

export default ManualFileHeader